module.exports = __webpack_public_path__ + "static/media/browser-logos.6404c64c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/how-it-works-requirements/browser-logos.png
// module id = 387
// module chunks = 0